export const currencyInfoList = [
  {
    key: 1,
    name: 'USD',
    description: 'United States Dollar',
    flag: 'circle-flags:us',
    symbol: '$',
    countryCode: 'us'
  },
  {
    key: 2,
    name: 'EUR', 
    description: 'Euro',
    flag: 'circle-flags:eu',
    symbol: '€',
    countryCode: 'eu'
  },
  {
    key: 3,
    name: 'GBP',
    description: 'British Pound',
    flag: 'circle-flags:gb',
    symbol: '£',
    countryCode: 'gb'
  },
  {
    key: 4,
    name: 'CAD',
    description: 'Canadian Dollar',
    flag: 'circle-flags:ca',
    symbol: 'C$',
    countryCode: 'ca'
  },
  {
    key: 5,
    name: 'AUD',
    description: 'Australian Dollar',
    flag: 'circle-flags:au',
    symbol: 'A$',
    countryCode: 'au'
  },
  {
    key: 6,
    name: 'AED',
    description: 'United Arab Emirates Dirham',
    flag: 'circle-flags:ae',
    symbol: 'د.إ',
    countryCode: 'ae'
  },
  {
    key: 7,
    name: 'INR',
    description: 'Indian Rupee',
    flag: 'circle-flags:in',
    symbol: '₹',
    countryCode: 'in'
  }
];

export const currencyFlagMap = {
  1: 'circle-flags:us',
  2: 'circle-flags:european-union', 
  3: 'circle-flags:uk',
  4: 'circle-flags:ca',
  5: 'circle-flags:au',
  6: 'circle-flags:ae',
  7: 'circle-flags:in'
};